/**
 * Field — Eyebrow label + form control wrapper. The design uses this
 * shape across every step of the builder + the email signup screen.
 *
 * Doesn't render the control itself — that's the caller's job. Helps
 * keep spacing + label typography uniform.
 */
import { ReactNode } from 'react';
import { Eyebrow } from './Eyebrow';

type Props = {
  label: string;
  hint?: ReactNode;        // small grey caption under the control (eg. "8+ chars")
  error?: string;
  children: ReactNode;
};

export function Field({ label, hint, error, children }: Props) {
  return (
    <div>
      <Eyebrow style={{ marginBottom: 8 }}>{label}</Eyebrow>
      {children}
      {(hint || error) && (
        <div style={{ marginTop: 6, fontSize: 12, color: error ? '#a8331f' : 'var(--ink-3)' }}>
          {error || hint}
        </div>
      )}
    </div>
  );
}
